import apiService from './apiService';
import settingsConfigurationService from '../settingsConfigurationService';

const mir3Service = {
    async getLocales() {
        const { mir3ApiBaseUrl } = settingsConfigurationService.get();

        return await apiService.get(`${mir3ApiBaseUrl}res/locales.json`);
    },

    async getTranslations(language) {
        const { mir3ApiBaseUrl } = settingsConfigurationService.get();

        return await apiService.get(`${mir3ApiBaseUrl}actions/verbiageLookup/${language.lcId}`);
    },

    async getLoginPageAnnouncement(language, organizationId) {
        const { mir3ApiBaseUrl } = settingsConfigurationService.get();
        const lcId = language?.lcId || 'en_US';

        return await apiService.get(
            `${mir3ApiBaseUrl}actions/verbiageLookup/${lcId}/announcement.loginPage`,
            organizationId == null ? undefined : { organizationId }
        );
    },
};

export default mir3Service;
